export default __webpack_public_path__ + "static/media/DonaldDiamond.a6388ac0.svg";